import BillsTable from '../../../components/table/bills/bills.table';
import { Grid, Typography } from '@mui/material';
import React from 'react';

/**
 * Page mes factures, comportant toutes les factures de tous les contrats
 * @constructor
 */
export default function MyBillsPage() {
    /**
     * Création de la page avec pour chaque contrat leur tableau de factures.
     */
    return (
        <Grid container spacing={6}>
            <Grid item xs={12} sx={{ marginTop: '10px' }}>
                <Typography variant="h4">Mes Factures</Typography>
            </Grid>
            <Grid item xs={12}>
                <BillsTable contract={undefined} />
            </Grid>
        </Grid>
    );
}
